import { render } from "./SellersPage.vue?vue&type=template&id=4b55fb10&scoped=true"
import script from "./SellersPage.vue?vue&type=script&lang=js"
export * from "./SellersPage.vue?vue&type=script&lang=js"

import "./SellersPage.vue?vue&type=style&index=0&id=4b55fb10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b55fb10"]])

export default __exports__